import './App.css';
import FormToAdd from './components/FormToAdd';


function App() {

  

  return (
    <div className="App">
           <h1>TO DO LIST </h1>
           <FormToAdd />
       

    </div>
  );
}

export default App;
